var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProductionAchievementRate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon_Production_achievement_rate"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_Production_achievement_rate",
    "data-name": "icon_Production achievement rate",
    clipPath: "url(#clip-icon_Production_achievement_rate)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1",
    "data-name": "Path 1",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.609,400.915a9.936,9.936,0,0,1-.77-2.335C208.119,399.351,208.364,400.121,208.609,400.915Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 208.6089935302734 400.9150085449219 C 208.2590026855469 400.1799926757813 208.0019989013672 399.3980102539063 207.8390045166016 398.5799865722656 C 208.1190032958984 399.3510131835938 208.3639984130859 400.1210021972656 208.6089935302734 400.9150085449219 Z",
    stroke: "none",
    fill: "#6e2124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M807.979,192.705a9.652,9.652,0,0,0,1.914-1.435Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 807.97900390625 192.7050018310547 L 809.8930053710938 191.2700042724609 C 809.3209838867188 191.8179931640625 808.6790161132813 192.3090057373047 807.97900390625 192.7050018310547 Z",
    stroke: "none",
    fill: "#6e2124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3",
    "data-name": "Path 3",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.314,346.406l-2.428-1.833A9.184,9.184,0,0,1,559.314,346.406Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 559.3140258789063 346.406005859375 L 556.885986328125 344.572998046875 C 557.7960205078125 345.052001953125 558.625 345.6700134277344 559.3140258789063 346.406005859375 Z",
    stroke: "none",
    fill: "#6e2124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_4",
    "data-name": "Path 4",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.146,192.554a9.318,9.318,0,0,1-1.576-1.179Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 463.14599609375 192.5540008544922 C 462.5740051269531 192.2149963378906 462.0490112304688 191.8179931640625 461.5700073242188 191.375 L 463.14599609375 192.5540008544922 Z",
    stroke: "none",
    fill: "#6e2124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_5",
    "data-name": "Path 5",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.768,191.281c-.105-.455-.2-.922-.291-1.377A9.027,9.027,0,0,1,311.768,191.281Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 311.7680053710938 191.281005859375 C 311.6629943847656 190.8260040283203 311.5700073242188 190.3589935302734 311.4769897460938 189.9040069580078 C 311.6050109863281 190.3480072021484 311.7099914550781 190.8139953613281 311.7680053710938 191.281005859375 Z",
    stroke: "none",
    fill: "#6e2124"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M886.778,99.783a74.666,74.666,0,0,0-74.667,74.667,76.286,76.286,0,0,0,.5,8.7c.023.187.047.385.07.572.023.28.035.56.035.852a9.354,9.354,0,0,1-2.825,6.7,9.652,9.652,0,0,1-1.914,1.435L675.242,292.258l-1.762,1.319a9.348,9.348,0,0,1-4.681,1.249,9.485,9.485,0,0,1-2.778-.42c-.012,0-.012,0-.023-.012-.572-.257-1.156-.5-1.751-.747a74.815,74.815,0,0,0-57.486.257c-.035.011-.07.035-.1.046a8.437,8.437,0,0,1-.957.4,9.218,9.218,0,0,1-3.081.526,9.33,9.33,0,0,1-5-1.436,11.389,11.389,0,0,1-1.191-.9L463.146,192.554a9.339,9.339,0,0,1-4.564-8.019c0-.21.012-.42.023-.619a7.779,7.779,0,0,1,.129-1.039,77.385,77.385,0,0,0,.467-8.427A74.668,74.668,0,1,0,311.477,189.9a9.027,9.027,0,0,1,.291,1.377c0,.012.012.024.012.035a8.974,8.974,0,0,1,.082,1.261,9.317,9.317,0,0,1-2.428,6.28c-.2.221-.409.432-.63.642a.6.6,0,0,1-.082.07L161.838,346.452a9.162,9.162,0,0,1-1.505,1.506A9.324,9.324,0,0,1,154.508,350a9.8,9.8,0,0,1-1.33-.094,9.7,9.7,0,0,1-1.191-.245,74.589,74.589,0,1,0,56.622,51.253,9.936,9.936,0,0,1-.77-2.335,10.345,10.345,0,0,1-.152-1.715,9.31,9.31,0,0,1,2.136-5.941.5.5,0,0,1,.07-.082,8.479,8.479,0,0,1,1.121-1.121.536.536,0,0,1,.081-.07L352.353,248.382a12.66,12.66,0,0,1,.969-.969,9.305,9.305,0,0,1,6.1-2.264,10.525,10.525,0,0,1,1.366.093c.934.327,1.879.63,2.825.9a74.939,74.939,0,0,0,49.735-2.79,7.986,7.986,0,0,1,1.027-.443,9.374,9.374,0,0,1,8.346,1.05c.257.175.49.35.723.537L556.886,344.573a9.475,9.475,0,0,1,5.007,7.435q-.281,1.892-.455,3.817-.315,3.4-.315,6.875a74.667,74.667,0,0,0,149.334,0c0-2.5-.128-4.961-.361-7.4-.1-1.039-.222-2.066-.374-3.093a9.191,9.191,0,0,1,2.685-6.117l.035-.035,2.159-1.61,131.862-98.9,3.326-2.5a9.252,9.252,0,0,1,3.817-.817,8.955,8.955,0,0,1,2.638.385q1.068.473,2.136.91a74.675,74.675,0,1,0,28.4-143.743ZM137.222,460.175a37.316,37.316,0,1,1,37.316-37.316A37.356,37.356,0,0,1,137.222,460.175ZM384.533,211.766a37.316,37.316,0,1,1,37.316-37.316A37.363,37.363,0,0,1,384.533,211.766ZM635.79,400.016A37.316,37.316,0,1,1,673.106,362.7,37.356,37.356,0,0,1,635.79,400.016Zm250.988-188.25a37.316,37.316,0,1,1,37.317-37.316A37.363,37.363,0,0,1,886.778,211.766Z",
    fill: "#5797d2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_7",
    "data-name": "Path 7",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.838,346.452a9.162,9.162,0,0,1-1.505,1.506Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 161.8379974365234 346.4519958496094 C 161.3950042724609 347.0130004882813 160.8930053710938 347.5140075683594 160.3329925537109 347.9580078125 L 161.8379974365234 346.4519958496094 Z",
    stroke: "none",
    fill: "#6e2124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_8",
    "data-name": "Path 8",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.838,346.452a9.162,9.162,0,0,1-1.505,1.506Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 161.8379974365234 346.4519958496094 C 161.3950042724609 347.0130004882813 160.8930053710938 347.5140075683594 160.3329925537109 347.9580078125 L 161.8379974365234 346.4519958496094 Z",
    stroke: "none",
    fill: "#6e2124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_9",
    "data-name": "Path 9",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.768,191.281c-.105-.455-.2-.922-.291-1.377A9.027,9.027,0,0,1,311.768,191.281Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 311.7680053710938 191.281005859375 C 311.6629943847656 190.8260040283203 311.5700073242188 190.3589935302734 311.4769897460938 189.9040069580078 C 311.6050109863281 190.3480072021484 311.7099914550781 190.8139953613281 311.7680053710938 191.281005859375 Z",
    stroke: "none",
    fill: "#6e2124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_10",
    "data-name": "Path 10",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.314,346.406l-2.428-1.833A9.184,9.184,0,0,1,559.314,346.406Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 559.3140258789063 346.406005859375 L 556.885986328125 344.572998046875 C 557.7960205078125 345.052001953125 558.625 345.6700134277344 559.3140258789063 346.406005859375 Z",
    stroke: "none",
    fill: "#6e2124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_11",
    "data-name": "Path 11",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M809.893,191.27a9.652,9.652,0,0,1-1.914,1.435Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 809.8930053710938 191.2700042724609 C 809.3209838867188 191.8179931640625 808.6790161132813 192.3090057373047 807.97900390625 192.7050018310547 L 809.8930053710938 191.2700042724609 Z",
    stroke: "none",
    fill: "#6e2124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_12",
    "data-name": "Path 12",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.146,192.554a9.318,9.318,0,0,1-1.576-1.179Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 463.14599609375 192.5540008544922 C 462.5740051269531 192.2149963378906 462.0490112304688 191.8179931640625 461.5700073242188 191.375 L 463.14599609375 192.5540008544922 Z",
    stroke: "none",
    fill: "#6e2124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_13",
    "data-name": "Path 13",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.609,400.915a9.936,9.936,0,0,1-.77-2.335C208.119,399.351,208.364,400.121,208.609,400.915Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 208.6089935302734 400.9150085449219 C 208.2590026855469 400.1799926757813 208.0019989013672 399.3980102539063 207.8390045166016 398.5799865722656 C 208.1190032958984 399.3510131835938 208.3639984130859 400.1210021972656 208.6089935302734 400.9150085449219 Z",
    stroke: "none",
    fill: "#6e2124"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 65.365,
    height: 239.97,
    rx: 28,
    transform: "translate(99.46 684.247)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 65.365,
    height: 239.97,
    rx: 28,
    transform: "translate(604.231 684.247)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 65.365,
    height: 492.237,
    rx: 28,
    transform: "translate(351.846 431.98)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 65.365,
    height: 492.237,
    rx: 28,
    transform: "translate(856.617 431.98)",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductionAchievementRate);
export default __webpack_public_path__ + "static/media/icon-productionAchievementRate.2502bfd2cef349d90e5496c4c55d5d33.svg";
export { ForwardRef as ReactComponent };